import { AsciiText } from './AsciiText';
import { CommandFormatter } from './CommandFormatter';
const options = {
    0x00: 'binary transmission',
    0x01: 'echo',
    0x02: 'reconnection',
    0x03: 'suppress go ahead',
    0x04: 'approx msg size negotiation',
    0x05: 'status',
    0x06: 'timing mark',
    0x07: 'remote controlled trans and echo',
    0x08: 'output line width',
    0x09: 'output page size',
    0x0a: 'output carraige return',
    0x0b: 'output horizontal tab stops',
    0x0c: 'output horizontal tab disposition',
    0x0d: 'output formfeed disposition',
    0x0e: 'output vertical tab stops',
    0x0f: 'output vertical tab disposition',
    0x10: 'output linefeed disposition',
    0x11: 'extended ascii',
    0x12: 'logout',
    0x13: 'byte macro',
    0x14: 'data entry terminal',
    0x15: 'SUPDUP',
    0x16: 'SUPDUP output',
    0x17: 'send location',
    0x18: 'terminal type',
    0x19: 'end of record',
    0x1a: 'TACACS user identification',
    0x1b: 'output marking',
    0x1c: 'terminal location number',
    0x1d: 'telnet 3270 regime',
    0x1e: 'X.3 PAD',
    0x1f: 'negotiate about window size',
    0x20: 'terminal speed',
    0x21: 'remote flow control',
    0x22: 'linemode',
    0x23: 'x display location',
    0x24: 'environment option',
    0x25: 'authentication option',
    0x26: 'encryption option',
    0x27: 'new environment option',
    0x28: 'TN3270E',
    0x29: 'XAUTH',
    0x2a: 'CHARSET',
    0x2b: 'telnet remote serial port',
    0x2c: 'com port control option',
    0x2d: 'telnet suppress local echo',
    0x2e: 'telnet start TLS',
    0x2f: 'KERMIT',
    0x30: 'SEND-URL',
    0x31: 'FORWARD_X',
    0x8a: 'TELOPT PRAGMA LOGON',
    0x8b: 'TELOPT SSPI LOGON',
    0x8c: 'TELOPT PRAGMA HEARTBEAT',
    0xff: 'extended options list',
};
export class TelnetNegotiator {
    constructor() {
        this.command = new Uint8Array(3);
        this.index = 0;
    }
    process(data, send, log) {
        return data.filter(datum => {
            var _a;
            if (this.index > 0 || datum === 0xff) {
                this.command[this.index++] = datum;
                if (this.index >= 3) {
                    const code = this.command[2];
                    const option = `${(_a = options[code]) !== null && _a !== void 0 ? _a : 'unknown'} (0x${code.toString(16)})`;
                    const fc = CommandFormatter.format(AsciiText.decode(this.command), true);
                    log(`received telnet command: ${fc}`);
                    this.index = 0;
                    switch (this.command[1]) {
                        case 0xfb: // will
                            log(`telnet: will ${option} -> responding don't`);
                            this.command[1] = 0xfe;
                            send(this.command);
                            break;
                        case 0xfc: // won't
                            log(`telnet: won't ${option}`);
                            break;
                        case 0xfd: // do
                            log(`telnet: do ${option} -> responding won't`);
                            this.command[1] = 0xfc;
                            send(this.command);
                            break;
                        case 0xfe: // don't
                            log(`telnet: don't ${option}`);
                            break;
                        default:
                            log('telnet: unexpected command');
                            break;
                    }
                }
                return false;
            }
            return true;
        }, this);
    }
    reset() {
        this.index = 0;
    }
}
